/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateScreenerLeadAdmissionFlagRequest } from './UpdateScreenerLeadAdmissionFlagRequest';
import {
    UpdateScreenerLeadAdmissionFlagRequestFromJSON,
    UpdateScreenerLeadAdmissionFlagRequestFromJSONTyped,
    UpdateScreenerLeadAdmissionFlagRequestToJSON,
    UpdateScreenerLeadAdmissionFlagRequestToJSONTyped,
} from './UpdateScreenerLeadAdmissionFlagRequest';

/**
 * 
 * @export
 * @interface UpdateScreenerLeadAdmissionFlag200Response
 */
export interface UpdateScreenerLeadAdmissionFlag200Response {
    /**
     * 
     */
    data?: UpdateScreenerLeadAdmissionFlagRequest;
}

/**
 * Check if a given object implements the UpdateScreenerLeadAdmissionFlag200Response interface.
 */
export function instanceOfUpdateScreenerLeadAdmissionFlag200Response(value: object): value is UpdateScreenerLeadAdmissionFlag200Response {
    return true;
}

export function UpdateScreenerLeadAdmissionFlag200ResponseFromJSON(json: any): UpdateScreenerLeadAdmissionFlag200Response {
    return UpdateScreenerLeadAdmissionFlag200ResponseFromJSONTyped(json, false);
}

export function UpdateScreenerLeadAdmissionFlag200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerLeadAdmissionFlag200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UpdateScreenerLeadAdmissionFlagRequestFromJSON(json['data']),
    };
}

export function UpdateScreenerLeadAdmissionFlag200ResponseToJSON(json: any): UpdateScreenerLeadAdmissionFlag200Response {
    return UpdateScreenerLeadAdmissionFlag200ResponseToJSONTyped(json, false);
}

export function UpdateScreenerLeadAdmissionFlag200ResponseToJSONTyped(value?: UpdateScreenerLeadAdmissionFlag200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UpdateScreenerLeadAdmissionFlagRequestToJSON(value['data']),
    };
}

